/**
===================================================
Module: frontend.src.components.SessionsList.tsx
Description: All sessions list component
Owner: Kawada Technosystem Co Ltd
All Rights Reserved
This script is proprietary and confidential.
Unauthorized copying, distribution, or modification of this
file, via any medium, is strictly prohibited.
===================================================
*/

import { Session } from "../types";
import SessionCard from "./SessionCard";

interface SessionsListProps {
  sessions: Session[];
  onSessionClick: (sessionId: string) => void;
  isLoading: boolean;
  isSelectionMode?: boolean;
  selectedSessions?: Set<string>;
  onSessionSelect?: (sessionId: string, isSelected: boolean) => void;
  onCancelSelection?: () => void;
}

const SessionsList: React.FC<SessionsListProps> = ({
  sessions,
  onSessionClick,
  isLoading,
  isSelectionMode = false,
  selectedSessions = new Set(),
  onSessionSelect,
  onCancelSelection,
}) => {
  if (isLoading) {
    return (
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        ファイルの読み込み中...
      </div>
    );
  }

  return (
    <div>
      {sessions.length === 0 ? (
        <div className="empty-state">
          ファイルがありません
        </div>
      ) : (
        <div className="sessions-list">
          {sessions.map((session) => (
            <SessionCard
              key={session.id}
              session={session}
              onClick={onSessionClick}
              isSelectionMode={isSelectionMode}
              isSelected={selectedSessions.has(session.id)}
              onSelect={onSessionSelect}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SessionsList;
